document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".product-description")
    .forEach(function (description) {
      const toggleBtn = description.nextElementSibling;

      if (!toggleBtn) return;

      // get line height
      const lineHeight = parseFloat(getComputedStyle(description).lineHeight);
      const maxHeight = lineHeight * 3 + 20; // clamp limit (3 lines)

      // check if text overflows
      if (description.scrollHeight > maxHeight) {
        toggleBtn.classList.remove("visually-hidden");
      }

      toggleBtn.addEventListener("click", function () {
        description.classList.toggle("product-description--expanded");
        toggleBtn.textContent = description.classList.contains(
          "product-description--expanded"
        )
          ? "Read less"
          : "Read more";
      });
    });
});
